<template>
  <section class="blog-eight-section">
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="section-heading section-heading-eight aos" data-aos="fade-up">
            <img src="@/assets/img/icons/dog.svg" alt="image">
            <h2>Our Blog </h2>
            <p>Here’s a compelling blog description designed to provide a clear idea</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="owl-carousel blog-eight-slider">
            <Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
              <Slide v-for="item in indexeightblog" :key="item.id">
                <div class="service-widget service-widget-eight aos" data-aos="fade-up">
                  <div class="service-img">
                    <router-link to="/blogs/blog-details">
                      <img class="img-fluid" alt="Service Image"
                      :src="require(`@/assets/img/blog/${item.image}`)">
                    </router-link>
                    <div class="service-eight-img-inside">
                      <router-link to="/blogs/blog-details">
                        <img src="@/assets/img/icons/dog-feet.svg" alt="image">
                        Read more
                      </router-link>	
                    </div>
                  </div>
                  <div class="service-content service-eight-blogs text-start">
                    <h3 class="title">
                      <router-link to="/blogs/blog-details">{{item.title}}</router-link>
                    </h3>
                    <p>{{item.content}}</p>
                    <div class="usefull-bottom useful-bottom-eight d-flex justify-content-between">
                      <router-link to="/service-provider/provider-details" class="useful-img">
                        <img :src="require(`@/assets/img/profiles/${item.avatar}`)" alt="User">
                        <span>Admin</span>
                      </router-link>
                      <h6><i class="feather-tag"></i>Grooming</h6>
                    </div>
                  </div>
                </div>
              </Slide>
              <template #addons>
                <Navigation />
              </template>
            </Carousel>
          </div>
        </div>
      </div>
      <div class="btn-sec btn-saloons btn-pets aos" data-aos="fade-up">
        <router-link to="/blogs/blog-grid" class="btn btn-primary btn-view">VIEW ALL BLOGS</router-link>
      </div>
    </div>
  </section>

  <section class="healthy-eight-section">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6 col-12">
          <div class="pets-content-all">
            <h2 class="mb-1">Keeping your pets</h2>
            <h1>Happy, Healthy And Safe!</h1>
            <p>Our dedicated support team is here to assist you every step of the way. Whether you have questions, need support, or require follow-up, we are responsive and ready to help.</p>
            <router-link to="/booking/user-booking" class="btn btn-primary rounded">Start Booking Now</router-link>
          </div>
        </div>
        <div class="col-lg-6 col-12">
          <div class="healthy-pets-img d-none d-lg-block">
            <img src="@/assets/img/healthy-pets.png" alt="image" class="img-fluid">
            <div class="healthy-eight-bg d-none d-md-block">
              <img src="@/assets/img/her-section-eight-bg.png" alt="image">
            </div>
            <div class="healthy-eight-bg-two d-none d-md-block">
              <img src="@/assets/img/her-section-eight-bg.png" alt="image">
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { Carousel, Pagination, Navigation, Slide } from "vue3-carousel";
import indexeightblog from "@/assets/json/indexeightblog.json";
import "vue3-carousel/dist/carousel.css";
export default {
  data() {
    return {
      indexeightblog: indexeightblog,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
        loop: true,
        margin: 24,
      },

      breakpoints: {
        575: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        // 700px and up
        767: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        // 991px and up
        991: {
          itemsToShow: 3,
          snapAlign: "center",
        },
        // 1024 and up
        1024: {
          itemsToShow: 3,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
};
</script>
